// @flow
import { CommonActions } from '@react-navigation/native';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';

import config from '../../../config';
import Navigation from '../../../lib/navigation';
import {isLoggedInSelector} from '../../../modules/Authentication';
import {
  getCreditableOptionsWithPlan,
  getLocalCreditableOptionsWithPlan,
  hasRoamingCreditableOptions,
} from '../../../modules/AvailableOption/selectors';
import {initNewOffer, setNewOffer} from '../../../modules/NewOffer/actions';
import {
  getCreditableOptionsWithPlanWithZeroValues,
  getLocalCreditableOptionsWithPlanWithZeroValues,
  isNewOfferValidSelector,
  newOfferPeriodicitySelector,
  newOfferPriceSelector,
} from '../../../modules/NewOffer/selectors';
import {clearChosenPhoneNumber} from '../../../modules/SignUp/PhoneNumber';
import {
  setCurrentVoucherDetails,
  setVoucherDetailsComeFrom,
  voucherCurrentVoucherDetailsSelector,
  voucherFilteredAvailableVouchersSelectorLazy,
  voucherComeFromSelector,
} from '../../../modules/Voucher';
import type {StateType} from '../../../modules/reducers';
import type {DispatchProps, FlaggedProps, StateProps} from './ChoosePlan';
import ChoosePlan from './ChoosePlan';
import {
  fetchActivationBonus,
  fetchFreeTrialActivationBonus,
} from '../../../modules/Bonuses';
import {freeTrialActivationBonusStateSelector} from '../../../modules/Bonuses';

const mapStateToProps = (state: StateType): StateProps => ({
  newOfferPrice: newOfferPriceSelector(state),
  newOfferPeriodicity: newOfferPeriodicitySelector(state),
  isOfferValid: isNewOfferValidSelector(state),
  isLoggedIn: isLoggedInSelector(state),
  comeFrom: voucherComeFromSelector(state),
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
  displayVouchersForChoosePlan: config.displayVouchersForChoosePlan,
  filteredAvailableVouchers:
    voucherFilteredAvailableVouchersSelectorLazy(state),
  creditableOptions: config.displayRoamingPlanSliders
    ? (config.addZeroOptionForEachService
        ? getLocalCreditableOptionsWithPlanWithZeroValues(state)
        : getLocalCreditableOptionsWithPlan(state))
    : (config.addZeroOptionForEachService
        ? getCreditableOptionsWithPlanWithZeroValues(state)
        : getCreditableOptionsWithPlan(state)),
  freeTrialActivationBonus: freeTrialActivationBonusStateSelector(state),
  hasRoamingOptions: hasRoamingCreditableOptions(state),
});

const mapDispatchToProps: DispatchProps = {
  clearChosenPhoneNumber,
  initNewOffer,
  clearOfferState: () => setNewOffer({plan: null, options: [], price: 0, changePlanDate: 'now'}),
  setVoucherDetailsComeFrom: (comeFrom: string) =>
    setVoucherDetailsComeFrom(comeFrom),
  setCurrentVoucherDetails: (object: Object) =>
    setCurrentVoucherDetails(object),
  fetchFreeTrial: () => fetchFreeTrialActivationBonus(),
};

const withFlaggedProps = (ownProps): FlaggedProps => ({
  selectThisPlan: () =>
    Navigation.dispatch(CommonActions.navigate({name: 'chooseNumber'})),
  displaySimIsAddedInOrder: config.displaySimIsAddedInOrder,
  isFreeSimPathAvailable: config.isFreeSimPathAvailable,
  displayPricesShownAreExclusiveOfTaxMessage:
    config.displayPricesShownAreExclusiveOfTaxMessage,
  displayLegalBlurb: config.displayLegalBlurb,
  orderType: 'SUBSCRIPTION',
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withFlaggedProps),
)(ChoosePlan);
